import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import SiteLoading from 'components/SiteLoading';
import Logger from 'logger';

const EXCEPTION_TYPE = {
  UNCAUGHT: 'UNCAUGHT',
  API_REQUEST: 'API_REQUEST',
  NETWORK: 'NETWORK'
};

class AppErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
    origin: PropTypes.string
  };

  static defaultProps = {
    children: null,
    origin: null
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.logError = this.logError.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.logError(error, info);
    this.setState({ hasError: true });
  }

  logError = (error, info) => {
    const { origin } = this.props;
    Logger.error({
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack,
      filename: origin,
      type: EXCEPTION_TYPE.UNCAUGHT
    });
  };

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <SiteLoading isLoaded className="error" title="" caption="Something's not quite right. Please try again or speak to your designated contact." />;
    }

    return children;
  }
}

export default AppErrorBoundary;
